module.exports = __webpack_public_path__ + "img/img_01.65daa1d5.jpg";